// src/app/core/interceptors/authentication.interceptor.ts
import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthStore } from '../store/auth.store';

function resolveTimezoneHeaders() {
  const headers: Record<string, string> = {};
  try {
    headers['X-Timezone'] = Intl.DateTimeFormat().resolvedOptions().timeZone ?? '';
    const offsetMin = -new Date().getTimezoneOffset();
    headers['X-Timezone-Offset'] = String(offsetMin);
  } catch { }
  return headers;
}

export const authenticationInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthStore);
  const token = auth.accessToken();
  const tzHeaders = resolveTimezoneHeaders();

  const setHeaders: Record<string, string> = {
    Accept: 'application/json',
    ...tzHeaders,
  };
  if (token) setHeaders['Authorization'] = `Bearer ${token}`;

  req = req.clone({ setHeaders });
  return next(req);
};
